module.exports = __webpack_public_path__ + "static/media/Inter-Italic.fd26ff23.woff2";